import { PublicClientApplication, LogLevel } from '@azure/msal-browser';
import F2WCustomLogger from 'Services/F2WCustomLogger';

export const msalConfig = {
  auth: {
    clientId: '62c26f28-0ccc-4082-ba5b-eb68497677df',
    authority: 'https://login.microsoftonline.com/e3e1f65b-b973-440d-b61c-bc895fc98e28',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
    secureCookies: false,
    claimsBasedCachingEnabled: true,
  },
  system: {
    allowNativeBroker: false,
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
    asyncPopups: false,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            F2WCustomLogger.error('MSAL Error', new Error(message), { service: 'MSAL' });
            break;
          case LogLevel.Warning:
            F2WCustomLogger.warn('MSAL Warning', { message, service: 'MSAL' });
            break;
          default:
            break;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
  extraScopesToConsent: [],
};

export const tokenRequest = {
  scopes: ['openid', 'profile', 'email'],
  extraScopesToConsent: [],
};

export const graphRequest = {
  scopes: ['User.Read'],
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL (will be called in index.js)
export const initializeMsal = async () => {
  await msalInstance.initialize();
};
